import { render, staticRenderFns } from "./ProofCustomSetting.vue?vue&type=template&id=af03bd0a"
import script from "./ProofCustomSetting.vue?vue&type=script&lang=js"
export * from "./ProofCustomSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports